import React  from "react";
import { Show,
    TabbedShowLayout,
    Tab,
} from 'react-admin';
import {useResourceOptions} from "../../hooks";
import {Title} from "../Common/Title";
import {productStock,location} from "../../resources";
import {SubResourceList} from "../Common/SubResourceList";
import {ListFinal as productstockList} from "../productstock/List"

export const ShowFinal = (props) =>
{
    const { readableFields, operations } = useResourceOptions(props.resource);
    return (
        <Show title={<Title resource={location.name}/>} {...props}>
            <TabbedShowLayout>
                <Tab label="Log">
                    <SubResourceList productdata={true} Component={productstockList} targetResource={productStock.name} recordType={'location'} location={props.location} id={props.id} match={props.match}/>
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};
